import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Papa from 'papaparse';

// Calcolo mese precedente
const oggi = new Date();
const meseCorrente = oggi.getMonth();
const annoCorrente = oggi.getFullYear();
const mesePrec = meseCorrente === 0 ? 11 : meseCorrente - 1;
const annoPrec = meseCorrente === 0 ? annoCorrente - 1 : annoCorrente;
const mesePrecedente = `${annoPrec}-${String(mesePrec + 1).padStart(2, '0')}`;

const ArchivioPresenze = () => {
  const [presenze, setPresenze] = useState([]);
  const [utenti, setUtenti] = useState([]);
  const [mese, setMese] = useState(mesePrecedente);
  const [utente, setUtente] = useState('');
  const [pagina, setPagina] = useState(1);
  const righePerPagina = 10;

  useEffect(() => {
    const fetchData = async () => {
      const resPresenze = await api.get('/archivio', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setPresenze(resPresenze.data);
      const resUtenti = await api.get('/utenti', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setUtenti(resUtenti.data);
    };
    fetchData();
  }, []);

  const formatOra = (val) => {
    if (!val) return '-';
    const d = new Date(val);
    return isNaN(d) ? '-' : d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  };

  const formatData = (val) => {
    if (!val) return '-';
    const d = new Date(val);
    return isNaN(d) ? '-' : d.toLocaleDateString('it-IT');
  };

  const calcolaOre = (inizio, fine) => {
    if (!inizio || !fine) return 0;
    const d1 = new Date(inizio);
    const d2 = new Date(fine);
    const diffMin = Math.floor((d2 - d1) / 60000);
    return diffMin > 0 ? diffMin : 0;
  };

  const minutiToHHMM = (minuti) => {
    const h = Math.floor(minuti / 60);
    const m = minuti % 60;
    return `${h}h ${String(m).padStart(2, '0')}m`;
  };

  const presenzeFiltrate = presenze.filter(p => {
    const dataPresenza = new Date(p.data_presenza);
    const dataMese = `${dataPresenza.getFullYear()}-${String(dataPresenza.getMonth() + 1).padStart(2, '0')}`;
    const matchMese = !mese || mese === dataMese;
    const matchUtente = !utente || utente === p.email;
    return matchMese && matchUtente;
  });

  const totalePagine = Math.ceil(presenzeFiltrate.length / righePerPagina);
  const presenzeMostrate = presenzeFiltrate.slice((pagina - 1) * righePerPagina, pagina * righePerPagina);

  const esportaPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, {
      head: [['Nome', 'Data', 'Entrata Matt', 'Uscita Matt', 'Entrata Pom', 'Uscita Pom', 'Ore']],
      body: presenzeFiltrate.map(p => {
        const oreMatt = calcolaOre(p.entrata_matt, p.uscita_matt);
        const orePom = calcolaOre(p.entrata_pom, p.uscita_pom);
        return [
          p.nome,
          formatData(p.data_presenza),
          formatOra(p.entrata_matt),
          formatOra(p.uscita_matt),
          formatOra(p.entrata_pom),
          formatOra(p.uscita_pom),
          minutiToHHMM(oreMatt + orePom)
        ];
      })
    });
    doc.save('presenze.pdf');
  };

  const esportaCSV = () => {
    const csv = Papa.unparse(presenzeFiltrate.map(p => {
      const oreMatt = calcolaOre(p.entrata_matt, p.uscita_matt);
      const orePom = calcolaOre(p.entrata_pom, p.uscita_pom);
      return {
        Nome: p.nome,
        Data: formatData(p.data_presenza),
        'Entrata Mattina': formatOra(p.entrata_matt),
        'Uscita Mattina': formatOra(p.uscita_matt),
        'Entrata Pomeriggio': formatOra(p.entrata_pom),
        'Uscita Pomeriggio': formatOra(p.uscita_pom),
        'Ore Totali': minutiToHHMM(oreMatt + orePom)
      };
    }));
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'presenze.csv';
    link.click();
  };

  const cambiaPagina = (nuova) => {
    if (nuova >= 1 && nuova <= totalePagine) setPagina(nuova);
  };

  const renderPaginazione = () => {
    const visibili = [];
    for (let i = 1; i <= totalePagine; i++) {
      if (i === 1 || i === totalePagine || Math.abs(i - pagina) <= 1) {
        visibili.push(i);
      } else if (visibili.at(-1) !== '...') {
        visibili.push('...');
      }
    }

    return (
      <div style={{ marginTop: '20px' }}>
        <button onClick={() => cambiaPagina(pagina - 1)} disabled={pagina === 1}>⬅</button>
        {visibili.map((num, i) =>
          num === '...' ? (
            <span key={i} style={{ margin: '0 6px' }}>...</span>
          ) : (
            <button
              key={i}
              onClick={() => cambiaPagina(num)}
              style={{ fontWeight: pagina === num ? 'bold' : 'normal' }}
            >
              {num}
            </button>
          )
        )}
        <button onClick={() => cambiaPagina(pagina + 1)} disabled={pagina === totalePagine}>➡</button>
      </div>
    );
  };

  return (
    <div>
      <h2>🗂️ Archivio Presenze</h2>

      <div style={{ marginBottom: '10px' }}>
        <label>📅 Mese: </label>
        <input type="month" value={mese} onChange={e => setMese(e.target.value)} />
        <label style={{ marginLeft: '20px' }}>👤 Utente: </label>
        <select value={utente} onChange={e => setUtente(e.target.value)}>
          <option value="">Tutti</option>
          {utenti.map(u => (
            <option key={u.user_id} value={u.email}>{u.nome}</option>
          ))}
        </select>
      </div>

      <button onClick={esportaPDF}>📄 Esporta PDF</button>
      <button onClick={esportaCSV} style={{ marginLeft: '10px' }}>📊 Esporta CSV</button>

      <table border="1" cellPadding="6" style={{ marginTop: '20px', width: '100%' }}>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Data</th>
            <th>Entrata Mattina</th>
            <th>Uscita Mattina</th>
            <th>Entrata Pomeriggio</th>
            <th>Uscita Pomeriggio</th>
            <th>Ore Totali</th>
          </tr>
        </thead>
        <tbody>
          {presenzeMostrate.map((p, i) => {
            const oreMatt = calcolaOre(p.entrata_matt, p.uscita_matt);
            const orePom = calcolaOre(p.entrata_pom, p.uscita_pom);
            return (
              <tr key={i}>
                <td>{p.nome}</td>
                <td>{formatData(p.data_presenza)}</td>
                <td>{formatOra(p.entrata_matt)}</td>
                <td>{formatOra(p.uscita_matt)}</td>
                <td>{formatOra(p.entrata_pom)}</td>
                <td>{formatOra(p.uscita_pom)}</td>
                <td>{minutiToHHMM(oreMatt + orePom)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {renderPaginazione()}
    </div>
  );
};

export default ArchivioPresenze;
